import { FC, MouseEvent, useState } from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import Spinner from '../../../../../../common/spinner/spinner';
import Routes from '../../../../../../constants/routes';
import Arrow from '../../../../../../images/header/arrow.svg';
import translation from '../../../../../../languages';
import qualityEvents from '../../../../../../services/quality-events';
import { SchoolMenuFilter } from '../../../../../../services/school/header-school-menu';
import cn from '../../../../../../utils/classnames';
import { landingLink } from '../../../../../../utils/landing-link';

const SchoolsBurgerMenu: FC<TranslationProps> = ({ t }) => {
    const { schools, isLoaded } = useSelector((state: RootState) => state.main.schoolClassification);
    const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
    const allTitle = t('header.schools.all');

    const toggleCategories = (e: MouseEvent<HTMLAnchorElement>, type: string) => {
        e.preventDefault();

        setSelectedCategories((prev) => (prev.includes(type) ? [...prev.filter((s) => s !== type)] : [...prev, type]));
    };

    const onAllSelect = (query: string) => {
        Promise.resolve().then(() => {
            qualityEvents.track({
                type: 'filter_setFilterSchoolType',
                query,
                source: 'navigation'
            });
        });
    };

    return (
        <div id='schools-burger-menu' className={cn('schools-burger-menu', { 'd-flex': !isLoaded })}>
            {isLoaded ? (
                <>
                    <div className='schools-menu-item'>
                        <NavLink
                            id='all-materials'
                            className='hover'
                            onClick={() => onAllSelect(allTitle)}
                            to={Routes.SCHOOL_LANDING_PAGES.prefix}
                        >
                            {allTitle}
                        </NavLink>
                    </div>
                    {schools.map(({ schoolName, type, subjects }) => (
                        <div key={schoolName} className='schools-menu-item'>
                            <NavLink id={type} to='' className='hover' onClick={(e) => toggleCategories(e, type)}>
                                {schoolName}
                                <span className='float-right'>
                                    <img
                                        alt=''
                                        className={selectedCategories.includes(type) ? 'unfolded-down' : ''}
                                        src={Arrow}
                                    />
                                </span>
                            </NavLink>
                            {selectedCategories.includes(type) && (
                                <div className='schools-list-wrapper'>
                                    <div className='schools-list-item'>
                                        <NavLink
                                            id={`all-materials-${type}`}
                                            to={landingLink({ type })}
                                            onClick={() => onAllSelect(`${allTitle}/${schoolName}`)}
                                        >
                                            {allTitle}
                                        </NavLink>
                                    </div>
                                    {subjects.map((subject) => (
                                        <div key={subject.id} className='schools-list-item'>
                                            <NavLink
                                                id={`${type}-${subject.id}`}
                                                to={landingLink({
                                                    category: { id: subject.id } as SchoolMenuFilter,
                                                    type
                                                })}
                                                onClick={() =>
                                                    onAllSelect(`${allTitle}/${schoolName}/${subject.title}`)
                                                }
                                            >
                                                {subject.title}
                                            </NavLink>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </>
            ) : (
                <Spinner />
            )}
        </div>
    );
};

const translate = translation('header');

export default translate(SchoolsBurgerMenu);
